import { render, staticRenderFns } from "./AboutExpand.vue?vue&type=template&id=a060957c&"
import script from "./AboutExpand.vue?vue&type=script&lang=js&"
export * from "./AboutExpand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports